import { Dialog, styled } from '@mui/material';

export const StyledDialog = styled(Dialog)({
  '& .MuiPaper-root': {
    margin: 0,
    background: 'transparent'
  }
});
